<template>
  <div>
    <slot name="target" :show="() => active = true"></slot>
    <ModalView v-model:active="active" :size="size">
      <template v-if="$slots.header" v-slot:header>
        <slot name="header" :hide="() => active = false"></slot>
      </template>
      <template v-if="$slots.body" v-slot:body>
        <slot name="body" :hide="() => active = false"></slot>
      </template>
      <template v-if="$slots.footer" v-slot:footer>
        <slot name="footer" :hide="() => active = false"></slot>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import {ref} from "vue";
import ModalView from "../../plugins/modal/ModalView.vue";

defineProps({
  size: String
});

const active = ref(false);
</script>

<style scoped>

</style>